import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

export const genaiApiDefinitions = prefixApi(
  "/genai",
  apiBuilder({
    alias: "generateGenAiParameters",
    method: "post",
    path: "/generate_parameters/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          product: z.string(),
          additional_context: z.string().optional(),
        }),
      },
    ],
    status: 200,
    response: z.object({
      prompt: z.string(),
      theme_list: z.object({
        locale: z.string(),
        totalCount: z.number(),
        themes: z.array(
          z.object({
            themeForDisplay: z.string(),
            themeId: z.string(),
          }),
        ),
      }),
    }),
  })
    .addEndpoint({
      alias: "submitImageGenerationRequest",
      method: "post",
      path: "/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            name: z.string(),
            prompt: z.string(),
            gvproduct: z.string(),
            theme_list: z
              .object({
                themeForDisplay: z.string(),
                themeId: z.string(),
              })
              .array(),
          }),
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .build(),
);
